'use strict';

import C2F from './C2F.filter';
import CalculateTime from './calculateTime.filter';
import ChallengeType from './challengeType.filter';
import DisplayLastUpdatedDate from './displayLastUpdatedDate.filter';
import F2C from './F2C.filter';
import FileSize from './fileSize.filter';
import FilterAndHideItem from './filterAndHideItem.filter';
import GetAttributeValue from './getAttributeValue.filter';
import GetItem from './getItem.filter';
import HtmlSafe from './htmlSafe.filter';
import LocationTypeDesc from './locationTypeDesc.filter';
import MessageData from './messageData.filter';
import MessageText from './messageText.filter';
import RecipientsStr from './recipientsStr.filter';
import UserName from './userName.filter';
import DeviceIcon from './deviceIcon.filter';
import SalesTaxRate from './salesTaxRate.filter';
import UserDescription from './userDescription.filter';
import FromNow from './fromNow.filter';
import TranslateOrDefault from './translateOrDefault.filter';
import TimezoneGmt from './timezoneGmt.filter';
import FormatPhoneNumber from './formatPhoneNumber.filter';

export default angular
  .module('maestro.filters', [
    C2F,
    CalculateTime,
    ChallengeType,
    DisplayLastUpdatedDate,
    F2C,
    FileSize,
    FilterAndHideItem,
    GetAttributeValue,
    GetItem,
    HtmlSafe,
    LocationTypeDesc,
    MessageData,
    MessageText,
    RecipientsStr,
    UserName,
    DeviceIcon,
    SalesTaxRate,
    UserDescription,
    FromNow,
    TranslateOrDefault,
    TimezoneGmt,
    FormatPhoneNumber,
  ])

  .name;
